import { z } from "zod";
import { Id, IsoDate, Siret } from "./common.ts";
import { endpoint } from "./endpoint.ts";

export const LegalForm = z.enum(["SASU", "SAS", "EURL", "SARL", "AE"]);
export type LegalForm = z.infer<typeof LegalForm>;

/** One company per account (board MX8). */
export const Company = z.object({
  id: Id,
  name: z.string(),
  legalForm: LegalForm,
  /** Null while the company is being created. */
  siret: Siret.nullable(),
  registeredAt: IsoDate.nullable(),
  /** Signed link to the company's logo (Paramètres › Mon dossier); null / absent = initials. */
  logoUrl: z.string().nullable().optional(),
});
export type Company = z.infer<typeof Company>;

export const companyApi = {
  get: endpoint({ id: "company.get", method: "GET", path: "/companies/:companyId", params: z.object({ companyId: Id }), response: Company }),
};
